<template>
  <path pid="0" d="M19.5 12h-13a1 1 0 000 2h13a1 1 0 000-2zM19.5 18h-13a1 1 0 000 2h13a1 1 0 000-2zM6.5 6a1 1 0 000 2h13a1 1 0 000-2z"/>
</template>
